import { MenuEnum } from "./menu-items.enum";

export class MenuConfiguration {
    visible: boolean;
}

function buildPredefinedMenuConfiguration() {
    let menu = new Map();
    menu.set(MenuEnum.NEW, { visible: true });
    menu.set(MenuEnum.UNDO, { visible: true });
    menu.set(MenuEnum.REDO, { visible: true });
    menu.set(MenuEnum.SUGGESTIONS, { visible: true });
    menu.set(MenuEnum.TEXT_ALIGNMENT, { visible: false });
    menu.set(MenuEnum.TEXT_FONT_SIZE, { visible: true });
    menu.set(MenuEnum.TEXT_FONT_FAMILY, { visible: true });
    menu.set(MenuEnum.TEXT_FONT_WEIGHT, { visible: true });
    menu.set(MenuEnum.TEXT_FONT_STYLE, { visible: true });
    menu.set(MenuEnum.TEXT_DECORATION, { visible: true });
    menu.set(MenuEnum.UNORDERED_LIST, { visible: true });
    menu.set(MenuEnum.ORDERED_LIST, { visible: true });
    menu.set(MenuEnum.MICROPHONE, { visible: false });
    return menu;
}
export const predefinedMenuConfiguration = buildPredefinedMenuConfiguration();

